export default "__VITE_PUBLIC_ASSET__597c5882__"